
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutcggDDldG7iMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as carbonidM0uz1Nuz3ZMeta } from "/vercel/path0/pages/carbonid.vue?macro=true";
import { default as indexH4tP14oTKIMeta } from "/vercel/path0/pages/careers/[slug]/index.vue?macro=true";
import { default as indexoPfiXD35qmMeta } from "/vercel/path0/pages/careers/index.vue?macro=true";
import { default as contactJnsDpYVejzMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as cookiesKBPlZe4JJJMeta } from "/vercel/path0/pages/cookies.vue?macro=true";
import { default as createPLmS6A92lbMeta } from "/vercel/path0/pages/dashboard/account/admin/baselines/create.vue?macro=true";
import { default as indexaEQWbyy1ovMeta } from "/vercel/path0/pages/dashboard/account/admin/baselines/index.vue?macro=true";
import { default as ceto_45apiwvskqluuFzMeta } from "/vercel/path0/pages/dashboard/account/admin/data-ingestion/ceto-api.vue?macro=true";
import { default as external_45apiAWQm8ofWSRMeta } from "/vercel/path0/pages/dashboard/account/admin/data-ingestion/external-api.vue?macro=true";
import { default as index7yilPfxuFwMeta } from "/vercel/path0/pages/dashboard/account/admin/data-ingestion/index.vue?macro=true";
import { default as websocketKLyqLxfGorMeta } from "/vercel/path0/pages/dashboard/account/admin/data-ingestion/websocket.vue?macro=true";
import { default as datarxP9AwJKVPMeta } from "/vercel/path0/pages/dashboard/account/admin/data.vue?macro=true";
import { default as index321c7MeAevMeta } from "/vercel/path0/pages/dashboard/account/admin/index.vue?macro=true";
import { default as indexYT5LoGMgPTMeta } from "/vercel/path0/pages/dashboard/account/admin/users/[id]/index.vue?macro=true";
import { default as add_45userzH9efktFR5Meta } from "/vercel/path0/pages/dashboard/account/admin/users/add-user.vue?macro=true";
import { default as indexLNKdIXUYPaMeta } from "/vercel/path0/pages/dashboard/account/admin/users/index.vue?macro=true";
import { default as indexrdIUR4jgy4Meta } from "/vercel/path0/pages/dashboard/carbonid/index.vue?macro=true";
import { default as indexO9FScDvRhIMeta } from "/vercel/path0/pages/dashboard/carbonid/insights/[id]/index.vue?macro=true";
import { default as indexmUcbGcBwvhMeta } from "/vercel/path0/pages/dashboard/carbonid/insights/index.vue?macro=true";
import { default as indexRIIpWdUktDMeta } from "/vercel/path0/pages/dashboard/index.vue?macro=true";
import { default as indexKehrVxwfxjMeta } from "/vercel/path0/pages/dashboard/insights/index.vue?macro=true";
import { default as indexUqjSC56rLPMeta } from "/vercel/path0/pages/dashboard/notifications/index.vue?macro=true";
import { default as profile9R2UgaCjXxMeta } from "/vercel/path0/pages/dashboard/profile.vue?macro=true";
import { default as index8QPODgCSrEMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/analytics/index.vue?macro=true";
import { default as trendsYLo0TUf350Meta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/analytics/trends.vue?macro=true";
import { default as anomaliesILhzuv88cqMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/anomalies.vue?macro=true";
import { default as indexju2WNHa1MOMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/index.vue?macro=true";
import { default as voyagescybaTXKt5rMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/voyages.vue?macro=true";
import { default as chartsum0LGSiFWcMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/data/charts.vue?macro=true";
import { default as indexf4Pq9vrV7PMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/data/index.vue?macro=true";
import { default as sensorsozuzEzPePDMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/data/sensors.vue?macro=true";
import { default as indexGD002nV7whMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/index.vue?macro=true";
import { default as indexhwh6cOZpfDMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/insights/[id]/index.vue?macro=true";
import { default as indexR9tIaP3vkHMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/insights/index.vue?macro=true";
import { default as performancevRN4LXcSYXMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/performance.vue?macro=true";
import { default as auxiliaryiUPhahvchWMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/auxiliary.vue?macro=true";
import { default as engineMEyTCUcT3BMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/engine.vue?macro=true";
import { default as feedzsYL0WFAtHMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/feed.vue?macro=true";
import { default as indexlohnWd8szVMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/index.vue?macro=true";
import { default as performanceS6YXajaVPWMeta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/performance.vue?macro=true";
import { default as indexZ4AyQmDHm6Meta } from "/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/index.vue?macro=true";
import { default as indexUdJxOZm6IQMeta } from "/vercel/path0/pages/dashboard/vessels/index.vue?macro=true";
import { default as designZ1nB18UMQkMeta } from "/vercel/path0/pages/design.vue?macro=true";
import { default as forgot_45password9RntqnVzd3Meta } from "/vercel/path0/pages/forgot-password.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as insuranceI3wRO2uGmQMeta } from "/vercel/path0/pages/insurance.vue?macro=true";
import { default as legalqwZTbXfdU3Meta } from "/vercel/path0/pages/legal.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as _91slug_93Dm5SRMWNSjMeta } from "/vercel/path0/pages/news/[slug].vue?macro=true";
import { default as indexxeWP9UFz4RMeta } from "/vercel/path0/pages/news/index.vue?macro=true";
import { default as privacykJ3SQnmrN4Meta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as reset_45password7wK2GPZgVKMeta } from "/vercel/path0/pages/reset-password.vue?macro=true";
import { default as terms_45and_45conditions0ynQwIk1xRMeta } from "/vercel/path0/pages/terms-and-conditions.vue?macro=true";
import { default as watchkeeper7JqDCnFt0YMeta } from "/vercel/path0/pages/watchkeeper.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutcggDDldG7iMeta || {},
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "carbonid",
    path: "/carbonid",
    meta: carbonidM0uz1Nuz3ZMeta || {},
    component: () => import("/vercel/path0/pages/carbonid.vue")
  },
  {
    name: "careers-slug",
    path: "/careers/:slug()",
    meta: indexH4tP14oTKIMeta || {},
    component: () => import("/vercel/path0/pages/careers/[slug]/index.vue")
  },
  {
    name: "careers",
    path: "/careers",
    meta: indexoPfiXD35qmMeta || {},
    component: () => import("/vercel/path0/pages/careers/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactJnsDpYVejzMeta || {},
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    meta: cookiesKBPlZe4JJJMeta || {},
    component: () => import("/vercel/path0/pages/cookies.vue")
  },
  {
    name: "dashboard-account-admin-baselines-create",
    path: "/dashboard/account/admin/baselines/create",
    meta: createPLmS6A92lbMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/baselines/create.vue")
  },
  {
    name: "dashboard-account-admin-baselines",
    path: "/dashboard/account/admin/baselines",
    meta: indexaEQWbyy1ovMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/baselines/index.vue")
  },
  {
    name: "dashboard-account-admin-data-ingestion-ceto-api",
    path: "/dashboard/account/admin/data-ingestion/ceto-api",
    meta: ceto_45apiwvskqluuFzMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/data-ingestion/ceto-api.vue")
  },
  {
    name: "dashboard-account-admin-data-ingestion-external-api",
    path: "/dashboard/account/admin/data-ingestion/external-api",
    meta: external_45apiAWQm8ofWSRMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/data-ingestion/external-api.vue")
  },
  {
    name: "dashboard-account-admin-data-ingestion",
    path: "/dashboard/account/admin/data-ingestion",
    meta: index7yilPfxuFwMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/data-ingestion/index.vue")
  },
  {
    name: "dashboard-account-admin-data-ingestion-websocket",
    path: "/dashboard/account/admin/data-ingestion/websocket",
    meta: websocketKLyqLxfGorMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/data-ingestion/websocket.vue")
  },
  {
    name: "dashboard-account-admin-data",
    path: "/dashboard/account/admin/data",
    meta: datarxP9AwJKVPMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/data.vue")
  },
  {
    name: "dashboard-account-admin",
    path: "/dashboard/account/admin",
    meta: index321c7MeAevMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/index.vue")
  },
  {
    name: "dashboard-account-admin-users-id",
    path: "/dashboard/account/admin/users/:id()",
    meta: indexYT5LoGMgPTMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/users/[id]/index.vue")
  },
  {
    name: "dashboard-account-admin-users-add-user",
    path: "/dashboard/account/admin/users/add-user",
    meta: add_45userzH9efktFR5Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/users/add-user.vue")
  },
  {
    name: "dashboard-account-admin-users",
    path: "/dashboard/account/admin/users",
    meta: indexLNKdIXUYPaMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/account/admin/users/index.vue")
  },
  {
    name: "dashboard-carbonid",
    path: "/dashboard/carbonid",
    meta: indexrdIUR4jgy4Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/carbonid/index.vue")
  },
  {
    name: "dashboard-carbonid-insights-id",
    path: "/dashboard/carbonid/insights/:id()",
    meta: indexO9FScDvRhIMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/carbonid/insights/[id]/index.vue")
  },
  {
    name: "dashboard-carbonid-insights",
    path: "/dashboard/carbonid/insights",
    meta: indexmUcbGcBwvhMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/carbonid/insights/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexRIIpWdUktDMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-insights",
    path: "/dashboard/insights",
    meta: indexKehrVxwfxjMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/insights/index.vue")
  },
  {
    name: "dashboard-notifications",
    path: "/dashboard/notifications",
    meta: indexUqjSC56rLPMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/notifications/index.vue")
  },
  {
    name: "dashboard-profile",
    path: "/dashboard/profile",
    meta: profile9R2UgaCjXxMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/profile.vue")
  },
  {
    name: "dashboard-vessels-vesselId-analytics",
    path: "/dashboard/vessels/:vesselId()/analytics",
    meta: index8QPODgCSrEMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/analytics/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-analytics-trends",
    path: "/dashboard/vessels/:vesselId()/analytics/trends",
    meta: trendsYLo0TUf350Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/analytics/trends.vue")
  },
  {
    name: "dashboard-vessels-vesselId-carbonid-anomalies",
    path: "/dashboard/vessels/:vesselId()/carbonid/anomalies",
    meta: anomaliesILhzuv88cqMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/anomalies.vue")
  },
  {
    name: "dashboard-vessels-vesselId-carbonid",
    path: "/dashboard/vessels/:vesselId()/carbonid",
    meta: indexju2WNHa1MOMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-carbonid-voyages",
    path: "/dashboard/vessels/:vesselId()/carbonid/voyages",
    meta: voyagescybaTXKt5rMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/carbonid/voyages.vue")
  },
  {
    name: "dashboard-vessels-vesselId-data-charts",
    path: "/dashboard/vessels/:vesselId()/data/charts",
    meta: chartsum0LGSiFWcMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/data/charts.vue")
  },
  {
    name: "dashboard-vessels-vesselId-data",
    path: "/dashboard/vessels/:vesselId()/data",
    meta: indexf4Pq9vrV7PMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/data/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-data-sensors",
    path: "/dashboard/vessels/:vesselId()/data/sensors",
    meta: sensorsozuzEzPePDMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/data/sensors.vue")
  },
  {
    name: "dashboard-vessels-vesselId",
    path: "/dashboard/vessels/:vesselId()",
    meta: indexGD002nV7whMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-insights-id",
    path: "/dashboard/vessels/:vesselId()/insights/:id()",
    meta: indexhwh6cOZpfDMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/insights/[id]/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-insights",
    path: "/dashboard/vessels/:vesselId()/insights",
    meta: indexR9tIaP3vkHMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/insights/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-performance",
    path: "/dashboard/vessels/:vesselId()/performance",
    meta: performancevRN4LXcSYXMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/performance.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages-voyageId-auxiliary",
    path: "/dashboard/vessels/:vesselId()/voyages/:voyageId()/auxiliary",
    meta: auxiliaryiUPhahvchWMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/auxiliary.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages-voyageId-engine",
    path: "/dashboard/vessels/:vesselId()/voyages/:voyageId()/engine",
    meta: engineMEyTCUcT3BMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/engine.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages-voyageId-feed",
    path: "/dashboard/vessels/:vesselId()/voyages/:voyageId()/feed",
    meta: feedzsYL0WFAtHMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/feed.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages-voyageId",
    path: "/dashboard/vessels/:vesselId()/voyages/:voyageId()",
    meta: indexlohnWd8szVMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/index.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages-voyageId-performance",
    path: "/dashboard/vessels/:vesselId()/voyages/:voyageId()/performance",
    meta: performanceS6YXajaVPWMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/[voyageId]/performance.vue")
  },
  {
    name: "dashboard-vessels-vesselId-voyages",
    path: "/dashboard/vessels/:vesselId()/voyages",
    meta: indexZ4AyQmDHm6Meta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/[vesselId]/voyages/index.vue")
  },
  {
    name: "dashboard-vessels",
    path: "/dashboard/vessels",
    meta: indexUdJxOZm6IQMeta || {},
    component: () => import("/vercel/path0/pages/dashboard/vessels/index.vue")
  },
  {
    name: "design",
    path: "/design",
    meta: designZ1nB18UMQkMeta || {},
    component: () => import("/vercel/path0/pages/design.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45password9RntqnVzd3Meta || {},
    component: () => import("/vercel/path0/pages/forgot-password.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    meta: insuranceI3wRO2uGmQMeta || {},
    component: () => import("/vercel/path0/pages/insurance.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: legalqwZTbXfdU3Meta || {},
    component: () => import("/vercel/path0/pages/legal.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/pages/login.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    meta: _91slug_93Dm5SRMWNSjMeta || {},
    component: () => import("/vercel/path0/pages/news/[slug].vue")
  },
  {
    name: "news",
    path: "/news",
    meta: indexxeWP9UFz4RMeta || {},
    component: () => import("/vercel/path0/pages/news/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacykJ3SQnmrN4Meta || {},
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password7wK2GPZgVKMeta || {},
    component: () => import("/vercel/path0/pages/reset-password.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    meta: terms_45and_45conditions0ynQwIk1xRMeta || {},
    component: () => import("/vercel/path0/pages/terms-and-conditions.vue")
  },
  {
    name: "watchkeeper",
    path: "/watchkeeper",
    meta: watchkeeper7JqDCnFt0YMeta || {},
    component: () => import("/vercel/path0/pages/watchkeeper.vue")
  }
]